import state from './state';
import actions from './actions';
import mutations from './mutations';


export default{
    state,
    mutations,
    actions,
};


// WEBPACK FOOTER //
// ./src/store/limit-sale/limit-sale.js